import request from '../../../services/request'
import {participants} from '../../../services/endpoints'

export default class participantsApi {
  static async getSchoolsByMatId(id) {
    if (!id) throw new Error('School MAT ID is required');
    try {
      return await request({
        url: participants.getSchoolsByMatId(id),
        method: 'GET',
      });
    } catch (err) {
      throw new Error('Failed to fetch schools by MAT ID');
    }
  }

  static async getStudentParent(id) {
    if (!id) throw new Error('Student ID is required');
    try {
      return await request({
        url: participants.getStudentParent(),
        method: 'POST',
        data: id,
      });
    } catch (err) {
      throw new Error('Failed to fetch student parent');
    }
  }

  static async checkPasscode(passcode) {
    if (!passcode) throw new Error('Passcode is required');
    try {
      return await request({
        url: participants.checkPasscode(),
        method: 'POST',
        data: JSON.stringify(passcode),
      });
    } catch (err) {
      throw new Error('Invalid or expired passcode');
    }
  }

  static async qrCodeVerify(passcode) {
    if (!passcode) throw new Error('QR code/passcode is required');
    try {
      return await request({
        url: participants.qrCodeVerify(),
        method: 'POST',
        data: JSON.stringify(passcode),
      });
    } catch (err) {
      throw new Error('QR code verification failed');
    }
  }

  static async sendLoginEmail(email) {
    if (!email) throw new Error('Email is required');
    try {
      return await request({
        url: participants.sendLoginEmail(),
        method: 'POST',
        data: JSON.stringify({ email }),
      });
    } catch (err) {
      throw new Error('Failed to send login email');
    }
  }

  static async verifyEmailToken(token) {
    if (!token) throw new Error('Token is required');
    try {
      return await request({
        url: participants.verifyEmailToken(),
        method: 'POST',
        data: JSON.stringify({ token }),
      });
    } catch (err) {
      // Keep the status. The endpoint answers 400 when the token will not decode and 404 when it
      // decodes to a pupil the lookup cannot find - two unrelated faults with two different fixes.
      // Flattening both into one message is why they have been indistinguishable from the outside,
      // in support tickets and in the console alike.
      const failure = new Error('Email token verification failed');
      failure.status = err?.status;
      failure.cause = err;
      throw failure;
    }
  }

  static async verifyStudent(data) {
    if (!data || !data.provider) {
      throw new Error('Provider field is required for social authentication');
    }
    try {
      return await request({
        url: participants.verifyStudent(),
        method: 'POST',
        data: JSON.stringify(data),
      });
    } catch (err) {
      throw new Error('Student verification by email failed');
    }
  }
}
